<template>
    <v-container id="DetalleReporte" class="pt-5">
        <div v-if="showcargando == true" id="cargando" wire:loading style="z-index: 600;"
            class="fixed top-0 left-0 right-0 bottom-0 w-full h-screen z-50 overflow-hidden bg-gray-700 opacity-75 flex flex-col items-center justify-center">
            <div class="loader ease-linear rounded-full border-4 border-t-4 h-12 w-12 mb-4"></div>
            <h2 class="text-center text-white text-xl font-semibold">Cargando...</h2>
            <p class="w-1/3 text-center text-white">
                Esto puede tardar unos segundos, no cierre esta página.
            </p>
        </div>
        <div v-show="showLightbox">
            <LightBox ref="lightbox" :media="media" :show-caption="true" :show-light-box="false"
                @onClosed="CerrarVisor()" />
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>

        <v-layout row wrap>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Abogado</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item style="padding-left:5px !important" title="Abogado: "
                                    :subtitle="this.detalleReporteData.prnombre">

                                    <v-row class="btnsAbo">
                                        <template v-if="this.detalleReporteData.medallaUrl != 'NA'">
                                            <div class="media-middle media-right" style="padding-left:0px">
                                                <img class="sq-100 btnMedalla"
                                                    :src="this.detalleReporteData.medallaUrl" />
                                            </div>

                                        </template>

                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">


                                                <v-btn v-on="on" v-bind="attrs" class="btnAbo" icon fab
                                                    @click="VistaProveedor(detalleReporteData.prclave)">
                                                    <v-icon class="btnCar" color="white">
                                                        mdi-account
                                                    </v-icon>
                                                </v-btn>

                                            </template>
                                            <span>Ver detalle</span>
                                        </v-tooltip>
                                        <v-tooltip top>
                                            <template v-slot:activator="{ on, attrs }">


                                                <v-btn v-on="on" v-bind="attrs" class="btnAboNew" icon fab
                                                    @click="VistaProveedorNewWindow(detalleReporteData.prclave)">
                                                    <v-icon class="btnsmall" color="white" size="12">
                                                        mdi-open-in-new
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Abrir en una nueva ventana</span>
                                        </v-tooltip>
                                    </v-row>

                                </vs-list-item>

                                <v-card-text>
                                    <span><a @click="Reasignaciones()">Reasignaciones</a></span>
                                </v-card-text>
                                <vs-list-item title="Lider:" :subtitle="this.detalleReporteData.usnom"></vs-list-item>
                                <v-card-text v-if="permisoReasignacionesLideres">
                                    <span><a @click="ReasignacionesLider()">Reasignaciones</a></span>
                                </v-card-text>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asegurado</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div v-if="validaEdicion">
                                <v-btn dark v-if="editasegurado" @click="Editar('Asegurado')" icon>
                                    <v-icon color>mdi-lead-pencil</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editasegurado" @click="Guardar('Asegurado')" icon>
                                    <v-icon color>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editasegurado" @click="editasegurado = true" icon>
                                    <v-icon color>mdi-keyboard-return</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formasegurado" v-model="valid" lazy-validation>
                                <vs-list>
                                    <template v-if="certificado.length > 0">
                                        <vs-list-item title="Número de Membresía: "
                                            :subtitle="certificado[0].dacertificado"></vs-list-item>
                                    </template>
                                    <template v-else>
                                        <vs-list-item title="Póliza: "
                                            :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
                                        <vs-list-item title="Inciso:"
                                            :subtitle="this.detalleReporteData.dainciso"></vs-list-item>
                                    </template>
                                    <!--<vs-list-item title="Póliza: "
                  :subtitle="this.detalleReporteData.dapoliza"></vs-list-item>
    <vs-list-item title="Inciso:"
                  :subtitle="this.detalleReporteData.dainciso"></vs-list-item>-->
                                    <vs-list-item title="Asegurado: "
                                        :subtitle="this.detalleReporteData.asnombre"></vs-list-item>
                                    <vs-list-item v-if="editasegurado" title="Sol./Cond:"
                                        :subtitle="this.detalleReporteData.svnomcond"></vs-list-item>
                                    <vs-list-item v-if="editasegurado" title="Dirección: "
                                        :subtitle="this.detalleReporteData.svdirasco"></vs-list-item>
                                    <vs-list-item v-if="editasegurado" id="correo" class="text-muted" title="E-mail:"
                                        :subtitle="this.detalleReporteData.svemail"></vs-list-item>
                                    <v-list-item-content v-if="!editasegurado">
                                        <span>Sol./Cond:</span>
                                        <v-text-field style="width:100%" v-model="asegurado.nombre" outlined
                                            maxlength="50" autofocus :rules="[rules.required]"
                                            v-on:blur="asegurado.nombre = asegurado.nombre.trim()"
                                            @keydown.enter.prevent>
                                        </v-text-field>
                                        <span>Dirección:</span>
                                        <v-text-field style="width:100%" v-model="asegurado.direccion" outlined
                                            maxlength="200" v-on:blur="asegurado.direccion = asegurado.direccion.trim()"
                                            @keydown.enter.prevent>
                                        </v-text-field>
                                        <span>E-mail:</span>
                                        <v-text-field style="width:100%" v-model="asegurado.correo" outlined
                                            maxlength="80" :rules="[rules.required, rules.email]"
                                            v-on:blur="asegurado.correo = asegurado.correo.trim()"
                                            @keydown.enter.prevent>
                                        </v-text-field>
                                    </v-list-item-content>
                                    <vs-list-item title="Vigencia: "
                                        :subtitle="this.detalleReporteData.dafecfin"></vs-list-item>
                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">
                                Datos del Vehiculo
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div v-if="validaEdicion">
                                <v-btn dark v-if="editaauto" @click="Editar('Auto')" icon>
                                    <v-icon color>mdi-lead-pencil</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editaauto" @click="Guardar('Auto')" icon>
                                    <v-icon color>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editaauto" @click="Cancelar('Auto')" icon>
                                    <v-icon color>mdi-keyboard-return</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-form ref="formauto" v-model="valid" lazy-validation>
                                <vs-list>
                                    <vs-list-item title="Número de Serie: "
                                        :subtitle="this.detalleReporteData.svserie"></vs-list-item>
                                    <vs-list-item title="Marca: "
                                        :subtitle="this.detalleReporteData.svmarca"></vs-list-item>
                                    <vs-list-item title="Modelo: "
                                        :subtitle="this.detalleReporteData.svmodelo"></vs-list-item>
                                    <vs-list-item title="Año: "
                                        :subtitle="this.detalleReporteData.svanio"></vs-list-item>
                                    <vs-list-item title="Color: "
                                        :subtitle="this.detalleReporteData.svcolor"></vs-list-item>
                                    <vs-list-item title="Placas: " v-if="editaauto"
                                        :subtitle="this.detalleReporteData.svplaca"></vs-list-item>
                                    <v-list-item-content v-if="!editaauto">
                                        <span>Placas:</span>
                                        <v-text-field style="width:100%" v-model="auto.placa" outlined maxlength="9"
                                            v-on:blur="auto.placa = auto.placa.trim()"
                                            :rules="[rules.required, rules.placamin]" @keydown.enter.prevent>
                                        </v-text-field>
                                    </v-list-item-content>
                                    <vs-list-item title="Número económico: "
                                        :subtitle="this.detalleReporteData.danumeco"></vs-list-item>
                                    <vs-list-item title="Monto Libro Azul: " v-if="editaauto"
                                        :subtitle="this.detalleReporteData.samontoazul"></vs-list-item>
                                    <v-list-item-content v-if="!editaauto">
                                        <span>Monto Libro Azul:</span>
                                        <v-text-field style="width:100%" v-model="auto.monto" @keypress="filter($event)"
                                            outlined maxlength="10" :rules="[rules.required, rules.monto]"
                                            v-on:blur="auto.monto = auto.monto.trim()" @keydown.enter.prevent>
                                        </v-text-field>
                                    </v-list-item-content>
                                </vs-list>
                            </v-form>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Asistencia</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item :subtitle="this.detalleReporteData.ainombre"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Posible Conclusión</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <div v-if="validaEdicion && ((permisolider && precierre == 0) || peredicion)">
                                <v-btn dark v-if="editaposible" @click="Editar('Posible')" icon>
                                    <v-icon color>mdi-lead-pencil</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editaposible" @click="Guardar('Posible')" icon>
                                    <v-icon color>mdi-content-save</v-icon>
                                </v-btn>
                                <v-btn dark v-if="!editaposible" @click="Cancelar('Posible')" icon>
                                    <v-icon color>mdi-keyboard-return</v-icon>
                                </v-btn>
                            </div>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item v-if="editaposible"
                                    :subtitle="this.detalleReporteData.pcnombre"></vs-list-item>
                                <v-list-item-content v-if="!editaposible" style="height: 100px">
                                    <span style="text-align: center;">{{ posibleconclusion.pcnombre }}</span>
                                    <multiselect placeholder="Seleccione un valor" :options="obtenerposible"
                                        v-model="posibleconclusion" label="pcnombre" track-by="pcid"
                                        :allow-empty="false" deselect-label="No se puede remover el valor seleccionado"
                                        selected-label="Seleccionado"
                                        style="z-index: 500; position: absolute; width: 96%;"
                                        select-label="Seleccionar valor" @input="seleccion()">
                                    </multiselect>
                                    <span style="color: red; position: absolute;" v-show="validarposible"
                                        class="mt-14">{{
                                            errorposible }}</span>
                                </v-list-item-content>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Aseguradora</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Aseguradora: " :subtitle="this.detalleReporteData.clnombre">
                                    <v-tooltip top
                                        v-if="detalleReporteData.clrutacontrato != null && detalleReporteData.clrutacontrato != ''">
                                        <template v-slot:activator="{ on, attrs }">

                                            <v-btn class="rounded-full btnAbo" icon dark v-on="on" v-bind="attrs"
                                                style="font-size: 20;" :loading="false" @click="VerContrato">
                                                <v-icon color>mdi mdi-file-document-multiple-outline</v-icon>
                                            </v-btn>

                                        </template>
                                        <span>Ver contrato</span>
                                    </v-tooltip>
                                </vs-list-item>

                                <vs-list-item title="Flotilla: "
                                    :subtitle="this.detalleReporteData.flnomcomp"></vs-list-item>
                                <vs-list-item v-if="this.detalleReporteData.flbroker != ''" title="Broker: "
                                    :subtitle="this.detalleReporteData.flbroker"></vs-list-item>
                            </vs-list>
                            <DetalleAgenteBox></DetalleAgenteBox>
                        </v-card-text>
                    </v-card>
                    <DatosEjecutivo></DatosEjecutivo>
                    <DatosContacto></DatosContacto>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Personas</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <v-list-item-content class="ms-1" v-if="editacausa">
                                    <span class="text-subtitle">
                                        Autoriza Servicio:
                                    </span>
                                    <p class="label-text2">
                                        <v-icon size="15" class="mr-1" v-if="validaEdicion"
                                            v-on:click="Editar('causa')">
                                            mdi-pencil
                                        </v-icon>
                                        {{ this.detalleReporteData.svcausa }}
                                    </p>
                                </v-list-item-content>
                                <v-list-item-content class="ms-1" v-if="!editacausa">
                                    <span class="text-subtitle">
                                        Autoriza Servicio:
                                    </span>
                                    <div>
                                        <v-form ref="formcausa" v-model="valid" lazy-validation>
                                            <v-text-field class="mx-1" :rules="[rules.required]" outlined autofocus
                                                maxlength="40" @keydown.enter.prevent v-on:blur="causa = causa.trim()"
                                                v-model="causa"></v-text-field>
                                        </v-form>
                                        <v-row>
                                            <v-spacer></v-spacer>
                                            <v-icon v-on:click="Guardar('causa')">
                                                mdi-content-save
                                            </v-icon>
                                            <span> </span>
                                            <v-icon v-on:click="Cancelar('causa')" class="mr-4">
                                                mdi-keyboard-return
                                            </v-icon>
                                        </v-row>
                                    </div>
                                </v-list-item-content>
                                <v-divider></v-divider>
                                <v-list-item-content class="ms-1" v-if="editadenuncia">
                                    <span class="text-subtitle">
                                        Denunciante:
                                    </span>
                                    <p class="label-text2">
                                        <v-icon size="15" class="mr-1" v-if="validaEdicion"
                                            v-on:click="Editar('denuncia')">
                                            mdi-pencil
                                        </v-icon>
                                        {{ this.detalleReporteData.svjuzgado }}
                                    </p>
                                </v-list-item-content>
                                <v-list-item-content class="ms-1" v-if="!editadenuncia">
                                    <span class="text-subtitle">
                                        Denunciante:
                                    </span>
                                    <div>
                                        <v-form ref="formdenuncia" v-model="valid" lazy-validation>
                                            <v-text-field class="mx-1" :rules="[rules.required]" outlined autofocus
                                                maxlength="50" @keydown.enter.prevent
                                                v-on:blur="denuncia = denuncia.trim()"
                                                v-model="denuncia"></v-text-field>
                                        </v-form>
                                        <v-row>
                                            <v-spacer></v-spacer>
                                            <v-icon v-on:click="Guardar('denuncia')">
                                                mdi-content-save
                                            </v-icon>
                                            <span> </span>
                                            <v-icon v-on:click="Cancelar('denuncia')" class="mr-4">
                                                mdi-keyboard-return
                                            </v-icon>
                                        </v-row>
                                    </div>
                                </v-list-item-content>
                                <v-divider></v-divider>
                                <vs-list-item title="Tercero Detenido: "
                                    v-if="this.detalleReporteData.saTerceroDet == ''"
                                    :subtitle="this.detalleReporteData.saTerceroDet"></vs-list-item>
                                <vs-list-item title="Tercero Detenido: " v-else
                                    :subtitle="this.detalleReporteData.saTerceroDet == 'true' ? 'Si' : 'No'"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3" v-if="this.detalleReporteData.tsclave == 1 &&
                        (this.detalleReporteData.trclave == 1 ||
                            this.detalleReporteData.trclave == 6 ||
                            this.detalleReporteData.trclave == 7 ||
                            this.detalleReporteData.trclave == 8)
                    ">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Montos</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item title="Monto estimado:"
                                    :subtitle="this.detalleReporteData.svesmonto"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md4>
                <v-card style="background-color: transparent !important" width="100%">
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Fechas</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <vs-list-item v-if="this.detalleReporteData.svfhsiniestro != ''" title="Siniestro:"
                                    :subtitle="this.detalleReporteData.svfhsiniestro"></vs-list-item>
                                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhsiniestro == ''">
                                    <span class="text-subtitle">
                                        Siniestro:
                                    </span>
                                    <p class="label-text2" v-if="validaEdicion && fechasiniestro">
                                        <v-icon size="16" class="mr-1" v-if="editarfechasin"
                                            v-on:click="Editar('fechasin')">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon size="16" class="mr-1" v-if="!editarfechasin"
                                            v-on:click="Guardar('fechasin')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon size="16" v-if="!editarfechasin"
                                            v-on:click="editarfechasin = !editarfechasin" class="mr-1">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </p>
                                    <div class="mt-2" v-if="!editarfechasin">
                                        <span class="text-subtitle">
                                            Fecha:
                                        </span>
                                        <div>
                                            <v-form ref="formsiniestrof" v-model="valid" lazy-validation>
                                                <v-menu ref="menu1" v-model="menu1" :close-on-content-click="false"
                                                    transition="scale-transition" offset-y maxlength="16"
                                                    max-width="290px" min-width="auto">
                                                    <template v-slot:activator="{ on, attrs }">
                                                        <v-text-field v-model="date" outlined readonly v-bind="attrs"
                                                            :rules="[rules.required]" v-on="on"></v-text-field>
                                                    </template>
                                                    <v-date-picker v-model="date" locale="es-mx"
                                                        @input="menu1 = false"></v-date-picker>
                                                </v-menu>
                                            </v-form>
                                        </div>
                                    </div>

                                </v-list-item-content>
                                <v-divider v-if="detalleReporteData.svfhsiniestro == ''"></v-divider>
                                <vs-list-item title="Reporte:"
                                    :subtitle="this.detalleReporteData.svfhreporte"></vs-list-item>
                                <vs-list-item title="Turnado:"
                                    :subtitle="this.detalleReporteData.svfhturnado"></vs-list-item>
                                <vs-list-item title="Estimada:"
                                    :subtitle="this.detalleReporteData.svfhestimada"></vs-list-item>
                                <vs-list-item v-if="detalleReporteData.svfhcontacto != ''" title="Contacto:"
                                    :subtitle="this.detalleReporteData.svfhcontacto"></vs-list-item>
                                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhcontacto == ''">
                                    <span class="text-subtitle">
                                        Contacto:
                                    </span>
                                    <p class="label-text2" v-if="validaEdicion">
                                        <v-icon size="16" class="mr-1" v-if="editarfecha"
                                            v-on:click="Editar('contacto')">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon size="16" class="mr-1" v-if="!editarfecha"
                                            v-on:click="Guardar('contacto')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha"
                                            class="mr-1">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </p>
                                    <div class="mt-2" v-if="!editarfecha">
                                        <span class="text-subtitle" v-if="PermisoSinIVR">
                                            Clave:
                                        </span>
                                        <span class="text-subtitle" v-else>
                                            Capturar IVR:
                                        </span>
                                        <div>
                                            <v-form ref="formcontacto" v-model="valid" lazy-validation>
                                                <v-text-field class="mx-1" label="" outlined maxlength="16" autofocus
                                                    :type="PermisoSinIVR ? 'password' : ''"
                                                    @keypress="PermisoSinIVR ? '' : filter($event)"
                                                    :rules="[rules.required]" @keydown.enter.prevent
                                                    v-on:blur="fhcontacto = fhcontacto.trim()"
                                                    v-model="fhcontacto"></v-text-field>
                                            </v-form>
                                        </div>
                                    </div>

                                </v-list-item-content>
                                <v-divider v-if="detalleReporteData.svfhcontacto == ''"></v-divider>
                                <vs-list-item v-if="detalleReporteData.svfhtermino != ''" title="Término:"
                                    :subtitle="this.detalleReporteData.svfhtermino"></vs-list-item>
                                <v-list-item-content class="ms-1" v-if="detalleReporteData.svfhtermino == ''">
                                    <span class="text-subtitle">
                                        Término:
                                    </span>
                                    <p class="label-text2"
                                        v-if="detalleReporteData.svfhcontacto != '' && validaEdicion">
                                        <v-icon size="16" class="mr-1" v-if="editarfecha"
                                            v-on:click="Editar('termino')">
                                            mdi-pencil
                                        </v-icon>
                                        <v-icon size="16" class="mr-1" v-if="!editarfecha"
                                            v-on:click="Guardar('termino')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon size="16" v-if="!editarfecha" v-on:click="editarfecha = !editarfecha"
                                            class="mr-1">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </p>
                                    <div class="mt-2" v-if="!editarfecha && detalleReporteData.svfhcontacto != ''">
                                        <v-form ref="formtermino" v-model="valid" lazy-validation>
                                            <span class="text-subtitle" v-if="PermisoSinIVR">
                                                Clave:
                                            </span>
                                            <span class="text-subtitle" v-else>
                                                Capturar IVR:
                                            </span>
                                            <div>

                                                <v-text-field class="mx-1" label="" autofocus outlined maxlength="16"
                                                    :type="PermisoSinIVR ? 'password' : ''"
                                                    @keypress="PermisoSinIVR ? '' : filter($event)"
                                                    :rules="[rules.required]" @keydown.enter.prevent
                                                    v-on:blur="fhcontacto = fhcontacto.trim()"
                                                    v-model="fhcontacto"></v-text-field>

                                            </div>
                                            <div>
                                                <span>Tercero Detenido:</span>
                                                <v-switch v-model="liberado" style="width: 40% !important;" class="ml-3"
                                                    inset></v-switch>
                                            </div>
                                        </v-form>
                                    </div>
                                </v-list-item-content>
                                <v-divider v-if="detalleReporteData.svfhtermino == ''"></v-divider>
                                <vs-list-item title="Conclusión:"
                                    :subtitle="this.detalleReporteData.svfhconclusion"></vs-list-item>
                                <vs-list-item title="Cerrado:"
                                    :subtitle="this.detalleReporteData.svfhcerrado"></vs-list-item>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Lugar de los Hechos</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <vs-list>
                                <v-textarea outlined v-model="this.detalleReporteData.svlughec" readonly filled
                                    rows="3">
                                </v-textarea>
                            </vs-list>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Observaciones</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-textarea outlined v-model="this.detalleReporteData.svconversa" readonly filled rows="3">
                            </v-textarea>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Opciones</v-toolbar-title>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row align="center">
                                <v-col cols="12" sm="6">
                                    <h5>Control de Citas</h5>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-center">
                                        <v-btn fab dark large color="success" @click="clickCitas">
                                            <v-icon dark>mdi-calendar-clock</v-icon>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                            <v-row align="center" v-if="permisoWhats">
                                <v-col cols="12" sm="6">
                                    <h5>Whatsapp</h5>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <div class="text-center">
                                        <v-btn fab dark large color="success" @click="clickWhatsapp" stacked>
                                            <v-badge color="error" v-if="showDot">
                                                <v-icon dark>mdi-whatsapp</v-icon>
                                            </v-badge>
                                            <v-btn v-if="showDot == false" fab dark large color="success" dot
                                                @click="clickWhatsapp">
                                                <v-icon dark>mdi-whatsapp</v-icon>
                                            </v-btn>
                                        </v-btn>
                                    </div>
                                </v-col>
                            </v-row>
                        </v-card-text>
                    </v-card>
                    <v-card flat class="text-xs-center ma-3">
                        <v-card-title class="justify-center primary">
                            <v-toolbar-title id="titulocard">Otros</v-toolbar-title>
                            <v-spacer></v-spacer>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <h5 class="mt-2 ml-1"><a @click="Seguimiento()">Seguimiento</a></h5>
                        </v-card-text>
                    </v-card>
                </v-card>
            </v-flex>
        </v-layout>
        <v-layout row wrap>
            <v-flex xs12 sm12 md12>
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Siniestro</v-toolbar-title>
                    </v-card-title>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Detalle</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <vs-list>
                            <vs-list-item title="Av. Previa:"
                                :subtitle="this.detalleReporteData.svnumave"></vs-list-item>
                            <v-list-item-content class="ms-1" v-if="editasiniestro">
                                <span class="text-subtitle">
                                    No. de siniestro:
                                </span>
                                <p class="label-text2">
                                    <v-icon size="15" class="mr-1" v-if="validaEdicion && user == ''"
                                        v-on:click="Editar('siniestro')">
                                        mdi-pencil
                                    </v-icon>
                                    {{ this.detalleReporteData.svnumsin }}
                                </p>
                            </v-list-item-content>
                            <v-list-item-content class="ms-1" v-if="!editasiniestro">
                                <span class="text-subtitle">
                                    No. de siniestro:
                                </span>
                                <div>
                                    <v-form ref="formsiniestros" v-model="valid" lazy-validation>
                                        <v-text-field class="mx-1"
                                            :rules="regex != '' ? ObtenerRegex() : [rules.required]"
                                            :placeholder="user == '' ? place : ''" outlined autofocus maxlength="20"
                                            @keydown.enter.prevent v-on:blur="blurSiniestro()"
                                            v-model="siniestro"></v-text-field>
                                    </v-form>
                                    <v-row>
                                        <v-spacer></v-spacer>
                                        <v-icon v-on:click="Guardar('siniestro')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon v-on:click="Cancelar('siniestro')" class="mr-4">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </v-row>
                                </div>
                            </v-list-item-content>
                            <v-divider></v-divider>
                            <vs-list-item title="Agencia:" :subtitle="this.detalleReporteData.agnomcve"></vs-list-item>
                            <vs-list-item title="Delegación:"
                                :subtitle="this.detalleReporteData.agdelega"></vs-list-item>
                            <vs-list-item title="Localidad:"
                                :subtitle="this.detalleReporteData.lonombre"></vs-list-item>
                            <vs-list-item title="Estado:" :subtitle="this.detalleReporteData.esnombre"></vs-list-item>
                            <v-list-item-content class="ms-1" v-if="editaajustador">
                                <span class="text-subtitle" v-if="this.detalleReporteData.clclave == 'SI'">
                                    Operador de servicio:
                                </span>
                                <span class="text-subtitle" v-else>
                                    Ajustador:
                                </span>
                                <p class="label-text2">
                                    <v-icon size="15" class="mr-1" v-if="validaEdicion && permisolider"
                                        v-on:click="Editar('ajustador')">
                                        mdi-pencil
                                    </v-icon>
                                    {{ this.detalleReporteData.svajustador }}
                                </p>
                            </v-list-item-content>
                            <v-list-item-content class="ms-1" v-if="!editaajustador">
                                <span class="text-subtitle" v-if="this.detalleReporteData.clclave == 'SI'">
                                    Operador de servicio:
                                </span>
                                <span class="text-subtitle" v-else>
                                    Ajustador:
                                </span>
                                <div>
                                    <v-form ref="formajustador" v-model="valid" lazy-validation>
                                        <v-text-field class="mx-1" label="" outlined maxlength="50"
                                            :rules="[rules.required]" v-on:blur="ajustador = ajustador.trim()"
                                            v-model="ajustador"></v-text-field>
                                    </v-form>
                                    <v-row>
                                        <v-spacer></v-spacer>
                                        <v-icon v-on:click="Guardar('ajustador')">
                                            mdi-content-save
                                        </v-icon>
                                        <span> </span>
                                        <v-icon v-on:click="Cancelar('ajustador')" class="mr-4">
                                            mdi-keyboard-return
                                        </v-icon>
                                    </v-row>
                                </div>
                            </v-list-item-content>
                            <v-divider></v-divider>
                        </vs-list>
                    </v-card-text>
                </v-card>
            </v-flex>
            <v-flex xs12 sm6 md6>
                <v-card flat class="text-xs-center ma-3" width="100%">
                    <v-card-title class="justify-center primary">
                        <v-toolbar-title id="titulocard">Tipo de servicio</v-toolbar-title>
                        <v-spacer></v-spacer>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <vs-list>
                            <!--<vs-list-item :subtitle="this.detalleReporteData.tsnombre"></vs-list-item>-->
                            <v-list-item-content class="ms-1">
                                <p class="label-text2">
                                    <v-icon size="15" class="mr-1" v-if="validaEdicion && pertiposer && editatiposer"
                                        v-on:click="Editar('tiposervicio')">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon v-if="validaEdicion && pertiposer && !editatiposer"
                                        v-on:click="Guardar('tiposervicio')">
                                        mdi-content-save
                                    </v-icon>
                                    <span> </span>
                                    <v-icon v-if="validaEdicion && pertiposer && !editatiposer"
                                        v-on:click="Cancelar('tiposervicio')" class="mr-1">
                                        mdi-keyboard-return
                                    </v-icon>
                                    {{ this.detalleReporteData.tsnombre }}
                                </p>
                            </v-list-item-content>
                            <vs-list-item v-if="detalleReporteData.tsclave == 8 && editatiposer"
                                :subtitle="this.detalleReporteData.TipoServicioOtro"></vs-list-item>

                            <div v-if="this.detalleReporteData.tsclave == 1">
                                <vs-list-item :subtitle="this.detalleReporteData.trdesc"></vs-list-item>
                                <div v-if="this.detalleReporteData.trdesc == 'Otros' && editatiposer">
                                    <span>Tipo de Robo</span>
                                    <vs-list>
                                        <vs-list-item v-if="this.TipoRobo.IsMerc == 'true'" title="Mercancía"
                                            :subtitle="this.TipoRobo.montoMer"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.IsEfec == 'true'" title="Efectivo"
                                            :subtitle="this.TipoRobo.montoEfe"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.IsActivoF == 'true'" title="Activo Fijo"
                                            :subtitle="this.TipoRobo.montoActivoF"></vs-list-item>
                                    </vs-list>
                                    <vs-list v-if="this.TipoRobo.IsActivoF == 'true'">
                                        <span>Tipo de activo Fijo</span>
                                        <vs-list-item v-if="this.TipoRobo.IsHandH == 'true'"
                                            subtitle="Hand Held"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.IsTablet == 'true'"
                                            subtitle="Tablet"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.IsLap == 'true'"
                                            subtitle="Lap top"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.IsImpre == 'true'"
                                            subtitle="Impresora"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.tbrotro == 'true'"
                                            subtitle="Otro"></vs-list-item>
                                        <vs-list-item v-if="this.TipoRobo.tbrotro == 'true'" title="Comentarios: "
                                            :subtitle="this.TipoRobo.tbrtextootro"></vs-list-item>
                                    </vs-list>
                                </div>
                            </div>
                            <v-form ref="frmtiposer" v-model="valid" lazy-validation>
                                <div v-if="pertiposer && !editatiposer">
                                    <span>Tipo de servicio</span>
                                    <v-select v-model="servicios" :items="tiposervicio" item-text="tsnombre"
                                        item-value="tsclave" :menu-props="{ maxHeight: '400' }"
                                        label="Seleccione un tipo de servicio"
                                        :rules="[v => !!v || 'Selección requerida']"
                                        @change="(valor) => changeServicio(valor)" dense solo
                                        persistent-hint></v-select>
                                    <div v-show="servicio == 1">
                                        <span>Tipo de servicio</span>
                                        <v-select v-model="robos" :items="tiporobo" item-text="trdesc"
                                            item-value="trclave" :menu-props="{ maxHeight: '400' }"
                                            label="Seleccione un tipo robo" dense solo
                                            @change="(valor) => changeRobo(valor)" persistent-hint></v-select>
                                        <span style="color: red;" v-show="validaser">Selección requerida</span>
                                    </div>
                                    <div v-if="servicio == 8">
                                        <v-textarea :counter="$store.state.maxLengthComentarios" :rules="rulestextarea"
                                            outlined v-model="observacion" required
                                            v-on:blur="observacion = observacion.trim()" name="input-7-4"></v-textarea>
                                    </div>
                                    <div v-if="robo == 9">
                                        <v-row>
                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="mercancia" label="Mercancía"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field style="width:100%" v-model="montomer"
                                                    @keypress="filter($event)" outlined maxlength="10"
                                                    :rules="mercancia ? [rules.required, rules.montomin] : []"
                                                    v-on:blur="montomer = montomer.trim()" :disabled="!mercancia"
                                                    @keydown.enter.prevent>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="efectivo" label="Efectivo"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field style="width:100%" v-model="montoefe"
                                                    @keypress="filter($event)" outlined maxlength="10"
                                                    :rules="efectivo ? [rules.required, rules.montomin] : []"
                                                    :disabled="!efectivo" v-on:blur="montoefe = montoefe.trim()"
                                                    @keydown.enter.prevent>
                                                </v-text-field>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-checkbox v-model="activofijo" :label="`Activo Fijo`"></v-checkbox>
                                            </v-col>
                                            <v-col cols="12" md="6">
                                                <v-text-field style="width:100%" v-model="montoact"
                                                    @keypress="filter($event)" outlined maxlength="10"
                                                    :rules="activofijo ? [rules.required, rules.montomin] : []"
                                                    :disabled="!activofijo" v-on:blur="montoact = montoact.trim()"
                                                    @keydown.enter.prevent>
                                                </v-text-field>
                                            </v-col>
                                        </v-row>
                                        <span style="color: red;" v-show="tipoactivo">Selección requerida</span>
                                        <div v-if="activofijo">
                                            <span>Tipo de activo fijo</span>
                                            <v-checkbox v-model="hand" label="Hand Held"></v-checkbox>
                                            <v-checkbox v-model="tablet" label="Tablet"></v-checkbox>
                                            <v-checkbox v-model="lap" label="Lap top"></v-checkbox>
                                            <v-checkbox v-model="impresora" label="Impresora"></v-checkbox>
                                            <span style="color: red;" v-show="tipoactivofijo">Selección requerida</span>
                                        </div>
                                    </div>
                                </div>
                            </v-form>
                            <vs-list>
                                <span style="font-weight: bold; color: #536dfe">Seguimiento</span>
                            </vs-list>
                        </vs-list>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
import { mapState, mapGetters, mapMutations } from "vuex";
import Reporte from "@/services/RLV/RLV.service.js";
import DatosContacto from "@/components/pages/DatosDeContacto/DatosContacto.vue";
import DatosEjecutivo from "@/components/pages/DatosEjecutivo/DatosEjecutivo.vue";
import MetodosGenerales from "@/utils/metodosgenerales.vue.js";
import WhatsappService from "@/services/Whatsapp/Whatsapp.service.js";
import General from '@/services/ReporteGeneral/ReporteGeneral.service.js';
import SerBusqueda from '@/services/Busqueda/Busqueda.service.js';
import '@/components/pages/Visor/dist/vue-image-lightbox.min.css';
import LightBox from '@/components/pages/Visor/LightBox.vue';
import ArchivosService from '@/services/Archivos/Archivos.service.js';

import DetalleAgenteBox from "@/components/pages/AsistenciaGeneral/components/DetalleAgenteBox.vue";

export default {
    title() {
        return this.$route.meta.title
    },
    components: {
        DatosContacto,
        DatosEjecutivo,
        LightBox,
        DetalleAgenteBox
    },
    data: function () {
        return {
            showcargando: true,
            detalleReporteData: [],
            svrobo: "",
            TipoRobo: [],
            showDot: false,
            permisoWhats: false,
            permisoReasignacionesLideres: false,
            //
            valid: true,
            datos: {},
            validaEdicion: false,
            validaposible: false,
            editasegurado: true,
            editaposible: true,
            editaauto: true,
            editadelito: true,
            editasiniestro: true,
            editaajustador: true,
            precierre: false,
            permisolider: false,
            pertiposer: false,
            asegurado: {
                reporte: '',
                indice: '',
                nombre: '',
                conductorfall: '',
                direccion: '',
                correo: '',
            },
            auto: {
                reporte: '',
                indice: '',
                placa: '',
                monto: ''
            },
            tipodelito: '',
            obtenerposible: [],
            posibleconclusion: [],
            validarposible: false,
            rules: {
                required: value => !!value || 'Campo requerido',
                counter: value => value.length <= 20 || 'Max 20 characters',
                email: value => {
                    const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Correo invalido'
                },
                monto: value => value >= 15000 && value <= 2000000 || 'Monto invalido',
                placamin: value => value.length >= 4 || 'La placa debe ser de mínimo 4 dígitos',
                montomin: value => value >= 10 || 'Monto invalido',
            },
            ///
            liberado: false,
            siniestro: null,
            ajustador: '',
            PermisoSinIVR: false,
            editarfecha: true,
            fhcontacto: '',
            fechasiniestro: false,
            editarfechasin: true,
            maxfecha: new Date().toISOString(),
            date: '',
            menu1: false,
            editacausa: true,
            causa: '',
            editadenuncia: true,
            denuncia: '',
            editatiposer: true,
            tiposervicio: [],
            tiporobo: [],
            servicios: {},
            servicio: {},
            robos: {},
            robo: 0,
            tsnombre: '',
            observacion: '',
            mercancia: false,
            efectivo: false,
            activofijo: false,
            montomer: '',
            montoefe: '',
            montoact: '',
            hand: false,
            tablet: false,
            lap: false,
            impresora: false,
            tipoactivo: false,
            tipoactivofijo: false,
            validaser: false,
            errorposible: '',
            user: '',
            regex: '',
            place: '',
            rulestextarea: [
                v => !!v || 'Campo requerido',
                v => {
                    if (v == null) {
                        return true
                    }
                    else {
                        if (v.length <= 12) {
                            return 'Mínimo 12 Carácteres'
                        }
                        else if (v.length > this.$store.state.maxLengthComentarios) {
                            return 'Máximo 500 Carácteres'
                        }
                        else
                            return true
                    }
                },
            ],
            peredicion: false,
            historial: [],
            certificado: [],
            asistenciaurl: '',
            //Ver contrato
            media: [{
                src: '@/',
                type: ''
            }],
            showLightbox: false,
            overlay: false,
        };
    },

    computed: {
        ...mapState({ drawer: (state) => state.drawer }),
        ...mapState(["domain", "informationPage"]),
        DRAWER_STATE: {
            get() {
                return this.drawer;
            },
        },
    },
    async mounted() {
        this.datos = await MetodosGenerales.obtenerSessionReporte("reporte");
        this.asistenciaurl = await MetodosGenerales.ObtenerURL(this.datos);
        this.ValidaEditar();
        this.changeReporteMenuOption("Detalle General");
        var datosReporte = new FormData();
        datosReporte.append("nrreporte", this.datos.nrreporte);
        datosReporte.append("svindice", this.datos.svindice);
        await General.ObtenerTipoCertificado(datosReporte).then(data => {
            this.certificado = data.result;
        });
        this.showcargando = true;

        await this.RevisarNotificacion();
        await this.DatosDetalle();
        await MetodosGenerales.HistorialBusqueda(this.datos, this.detalleReporteData.clnombrecorto);
        await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "358"
        ).then((response) => {
            if (response.data.length > 0) {
                this.permisoWhats = true;
            }
        });

        await MetodosGenerales.verificarPermisoSolo(
            this.domain.domainNameForApi,
            "VerificarPermiso",
            "62"
        ).then((response) => {
            if (response.data.length > 0) {
                this.permisoReasignacionesLideres = true;
            }
        });
    },
    watch: {
        'mercancia': function () {
            if (this.mercancia == false)
                this.montomer = 0;
            else
                this.tipoactivo = false;
        },
        'efectivo': function () {
            if (this.efectivo == false)
                this.montoefe = 0;
            else
                this.tipoactivo = false;
        },
        'activofijo': function () {
            if (this.activofijo == false) {
                this.montoact = 0;
                this.hand = false;
                this.tablet = false;
                this.lap = false;
                this.impresora = false;
            }
            else
                this.tipoactivo = false;
        },
        'hand': function () {
            if (this.hand)
                this.tipoactivofijo = false;
        },
        'tablet': function () {
            if (this.tablet)
                this.tipoactivofijo = false;
        },
        'lap': function () {
            if (this.lap)
                this.tipoactivofijo = false;
        },
        'impresora': function () {
            if (this.impresora)
                this.tipoactivofijo = false;
        }
    },
    methods: {
        ...mapMutations(["changeReporteMenuOption"]),
        blurSiniestro() {

            this.siniestro = this.siniestro = this.siniestro != null ? this.siniestro.trim() : null;

            const regex = new RegExp(this.regex); // Regex dinámica
            if (this.detalleReporteData.clclave == 'GSEG') {
                if (!regex.test(this.siniestro)) {
                    return;
                }
                else {

                    let dato = this.siniestro;

                    // Dividimos el dato en sus partes por el separador '/'
                    let partes = dato.split('/');

                    // Definimos las longitudes deseadas para cada segmento
                    let longitudes = [3, 3, 6, 4];

                    // Completamos cada parte al formato deseado
                    let datoFormateado = partes
                        .map((parte, index) => parte.padStart(longitudes[index], '0')) // Rellenamos con ceros a la izquierda
                        .join('/'); // Unimos nuevamente con '/'

                    this.siniestro = datoFormateado;
                }
            }
        },
        ObtenerRegex(value) {
            var resultRules = [];
            if (this.regex != '') {
                resultRules.push(
                    (v) => new RegExp(this.regex).test(v) || this.mensage
                );
                return resultRules;
            }
            else {
                return;
            }
        },
        async VistaProveedor(prclaveP) {

            let reporte = {
                nrreporte: String(this.datos.nrreporte),
                svindice: String(this.datos.svindice),
                aiclave: String(this.datos.aiclave),
                svfhconclusion: String(this.datos.svfhconclusion),
                prclave: String(prclaveP)

            };


            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);

        },

        async VistaProveedorNewWindow(prclaveP) {

            let reporte = {
                nrreporte: String(this.datos.nrreporte),
                svindice: String(this.datos.svindice),
                aiclave: String(this.datos.aiclave),
                svfhconclusion: String(this.datos.svfhconclusion),
                prclave: String(prclaveP)

            };


            await MetodosGenerales.guardarEnSesionInfoReporte(reporte, 'reporte');

            //this.$router.push({ name: 'DetalleAbogado' }).catch((error) => error);
            const routeData = this.$router.resolve({ name: 'DetalleAbogado' });
            window.open(routeData.href, '_blank');
        },

        changeRobo(valor) {
            this.robo = valor;
            this.validaser = false;

            this.mercancia = false;
            this.efectivo = false;
            this.activofijo = false;
            this.montomer = 0;
            this.montoefe = 0;
            this.montoact = 0;
            this.hand = false;
            this.tablet = false;
            this.lap = false;
            this.impresora = false;
        },
        async changeServicio(valor) {
            this.validaser = false;
            this.servicio = valor;
            this.robo = 0;
            this.robos = {};
            if (valor == 1) {
                await Reporte.TipoRobo(this).then(data => {
                    this.tiporobo = data;
                    if (this.detalleReporteData.trclave != '') {
                        for (let x in data) {
                            if (data[x].trclave == parseInt(this.detalleReporteData.trclave)) {
                                this.robos = data[x];
                                this.robo = data[x].trclave;
                            }
                        }
                    }
                });
            }
            else {
                this.mercancia = false;
                this.efectivo = false;
                this.activofijo = false;
                this.montomer = 0;
                this.montoefe = 0;
                this.montoact = 0;
                this.hand = false;
                this.tablet = false;
                this.lap = false;
                this.impresora = false;
            }
        },
        async Guardar(dato) {
            let datos = [];
            if (dato == 'Asegurado') {
                this.asegurado.nombre = this.asegurado.nombre.trim();
                this.asegurado.nombre = this.asegurado.nombre.replace(/\s*$/, "");
                this.asegurado.direccion = this.asegurado.direccion.trim();
                this.asegurado.direccion = this.asegurado.direccion.replace(/\s*$/, "");
                this.asegurado.correo = this.asegurado.correo.trim();
                this.asegurado.correo = this.asegurado.correo.replace(/\s*$/, "");
                if (this.$refs.formasegurado.validate()) {
                    this.showcargando = true;
                    datos.push(this.asegurado);

                    var datosReporte = new FormData();
                    datosReporte.append("data", JSON.stringify(datos));
                    await General.GuardarAsegurado(this, datosReporte).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editasegurado = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });


                }
            }
            else if (dato == 'Posible') {
                if (this.posibleconclusion.length == 0) {
                    this.validarposible = true;
                    this.errorposible = 'Selección requerida';
                }

                if (this.validarposible == false) {
                    this.showcargando = true;
                    var datosReporte = new FormData();
                    datosReporte.append("nrreporte", this.datos.nrreporte);
                    datosReporte.append("svindice", this.datos.svindice);
                    datosReporte.append("pcid", this.posibleconclusion.pcid);
                    await General.GuardarPosibleConclusion(this, datosReporte).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editaposible = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'Auto') {
                this.auto.placa = this.auto.placa.trim();
                this.auto.placa = this.auto.placa.replace(/\s*$/, "");
                if (this.$refs.formauto.validate()) {
                    this.showcargando = true;
                    var datosReporte = new FormData();
                    datosReporte.append("reporte", this.datos.nrreporte);
                    datosReporte.append("indice", this.datos.svindice);
                    datosReporte.append("placa", this.auto.placa);
                    datosReporte.append("monto", this.auto.monto);
                    await General.DatosVehiculo(this, datosReporte).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editaauto = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }

            }
            else if (dato == 'siniestro') {
                this.siniestro = this.siniestro.trim();
                this.siniestro = this.siniestro.replace(/\s*$/, "");
                if (this.$refs.formsiniestros.validate()) {
                    this.showcargando = true;
                    var datosReporte = new FormData();
                    datosReporte.append("reporte", this.datos.nrreporte);
                    datosReporte.append("indice", this.datos.svindice);
                    datosReporte.append("numsiniestro", this.siniestro);
                    await General.GuardarNumSiniestro(this, datosReporte).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editasiniestro = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }

            }
            else if (dato == 'ajustador') {
                this.ajustador = this.ajustador.trim();
                this.ajustador = this.ajustador.replace(/\s*$/, "");
                if (this.$refs.formajustador.validate()) {
                    this.showcargando = true;
                    var datosReporte = new FormData();
                    datosReporte.append("reporte", this.datos.nrreporte);
                    datosReporte.append("indice", this.datos.svindice);
                    datosReporte.append("ajustador", this.ajustador);
                    await General.GuardarAjustador(this, datosReporte).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editaajustador = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }

            }
            else if (dato == 'contacto') {
                this.fhcontacto = this.fhcontacto.trim();
                this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
                if (this.$refs.formcontacto.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("clave", this.fhcontacto);
                    formdata.append("permiso", this.PermisoSinIVR);
                    formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
                    await General.ActualizarContacto(this, formdata).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editarfecha = true;
                        }
                        else if (data[0].success == 'acceso') {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "info"
                            );
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'termino') {
                this.fhcontacto = this.fhcontacto.trim();
                this.fhcontacto = this.fhcontacto.replace(/\s*$/, "");
                if (this.$refs.formtermino.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("clave", this.fhcontacto);
                    formdata.append("svconlib", this.liberado);
                    formdata.append("permiso", "297");
                    formdata.append("uslogin", MetodosGenerales.ObtenerUserName());
                    await General.ActualizarTermino(this, formdata).then(data => {
                        if (data[0].success == 'true') {
                            this.DatosDetalle();
                            this.editarfecha = true;
                            this.$emit('RecargarMenu');
                        }
                        else if (data[0].success == 'acceso') {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "info"
                            );
                        }
                        else {
                            this.$swal(
                                "Atención",
                                data[0].mensaje,
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });

                }
            }
            else if (dato == 'fechasin') {

                if (this.$refs.formsiniestrof.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("fechasiniestro", this.date);

                    Reporte.GuardaFechaSiniestro(this, formdata).then(data => {
                        if (data) {
                            this.DatosDetalle();
                            this.editarfechasin = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                "Ocurrio un error al intentar nuevamente",
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'causa') {
                if (this.$refs.formcausa.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("causa", this.causa);
                    Reporte.ActualizarCausa(this, formdata).then(data => {
                        if (data) {
                            this.DatosDetalle();
                            this.editacausa = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                "Ocurrio un error al intentar nuevamente",
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'denuncia') {
                if (this.$refs.formdenuncia.validate()) {
                    this.showcargando = true;
                    let formdata = new FormData();
                    formdata.append("nrreporte", this.datos.nrreporte);
                    formdata.append("svindice", this.datos.svindice);
                    formdata.append("denuncia", this.denuncia);
                    Reporte.ActualizarDenuncia(this, formdata).then(data => {
                        if (data) {
                            this.DatosDetalle();
                            this.editadenuncia = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                "Ocurrio un error al intentar nuevamente",
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
            else if (dato == 'tiposervicio') {

                if (this.servicio == 1 && this.robo == 0)
                    this.validaser = true;
                else {
                    this.validaser = false;
                    this.tipoactivo = false;
                    this.tipoactivofijo = false;
                }
                if (this.robo == 9) {
                    if (!this.mercancia && !this.efectivo && !this.activofijo)
                        this.tipoactivo = true;


                }

                if (this.activofijo) {
                    if (!this.hand && !this.tablet && !this.lap && !this.impresora)
                        this.tipoactivofijo = true;
                    else
                        this.tipoactivofijo = false;
                }


                if (this.$refs.frmtiposer.validate() && this.tipoactivo == false && this.tipoactivofijo == false && this.validaser == false) {
                    this.showcargando = true;
                    let frmdata = new FormData();
                    frmdata.append("reporte", this.datos.nrreporte);
                    frmdata.append("indice", this.datos.svindice);
                    frmdata.append("aiclave", this.datos.aiclave);
                    frmdata.append("servicio", this.servicio);
                    frmdata.append("TRobo", this.robo);
                    frmdata.append("sOtro", this.observacion);
                    frmdata.append("IsMerc", this.mercancia);
                    frmdata.append("IsEfec", this.efectivo);
                    frmdata.append("IsActivoF", this.activofijo);
                    frmdata.append("montoMerc", this.montomer);
                    frmdata.append("montoEfec", this.montoefe);
                    frmdata.append("montoActivoF", this.montoact);
                    frmdata.append("IsHandH", this.hand);
                    frmdata.append("IsTablet", this.tablet);
                    frmdata.append("IsLap", this.lap);
                    frmdata.append("IsImpre", this.impresora);
                    Reporte.ActualizarTipoServicio(this, frmdata).then(data => {
                        if (data) {
                            this.DatosDetalle();
                            this.editatiposer = true;
                        }
                        else {
                            this.$swal(
                                "Atención",
                                "Ocurrio un error al intentar nuevamente",
                                "warning"
                            );
                        }
                        this.showcargando = false;
                    });
                }
            }
        },
        async Editar(dato) {
            if (dato == 'Asegurado') {
                this.editasegurado = false;
                this.asegurado.nombre = this.detalleReporteData.svnomcond;
                if (this.detalleReporteData.sacondfallecio != '')
                    this.asegurado.conductorfall = this.detalleReporteData.sacondfallecio == 'Si' ? "1" : "2";
                this.asegurado.direccion = this.detalleReporteData.svdirasco;
                this.asegurado.correo = this.detalleReporteData.svemail;
                this.asegurado.reporte = this.datos.nrreporte;
                this.asegurado.indice = this.datos.svindice;
            }
            else if (dato == 'Posible') {
                let frmdata = new FormData();
                frmdata.append("grupo", 'RLV');
                this.editaposible = false;
                await General.PosibleConclusion(this, frmdata).then(data => {
                    this.obtenerposible = data;
                    for (let x in data) {
                        if (data[x].pcnombre == this.detalleReporteData.pcnombre) {
                            this.posibleconclusion = data[x];
                        }
                    }
                });
            }
            else if (dato == 'Auto') {
                this.editaauto = false;
                this.auto.placa = this.detalleReporteData.svplaca;
                this.auto.monto = this.detalleReporteData.samontoazul;
            }
            else if (dato == 'siniestro') {
                this.editasiniestro = false;
                this.siniestro = this.detalleReporteData.svnumsin;
            }
            else if (dato == 'ajustador') {
                this.editaajustador = false;
                this.ajustador = this.detalleReporteData.svajustador;
            }
            else if (dato == 'contacto') {
                if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
                    this.editarfecha = !this.editarfecha;
                    this.fhcontacto = '';
                }
                else {
                    this.$swal(
                        "Atención",
                        "El reporte debe de estar turnado para ingresar la fecha de Contacto",
                        "info"
                    );
                }
            }
            else if (dato == 'termino') {
                if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
                    this.editarfecha = !this.editarfecha;
                    this.liberado = false;
                    this.fhcontacto = '';
                }
                else {
                    this.$swal(
                        "Atención",
                        "El reporte debe de estar turnado para ingresar la fecha de Término",
                        "info"
                    );
                }

            }
            else if (dato == 'fechasin') {
                if (this.detalleReporteData.prclave.substring(0, 5) != 'PENDI') {
                    this.editarfechasin = !this.editarfechasin;
                    this.fhcontacto = '';
                }
                else {
                    this.$swal(
                        "Atención",
                        "El reporte debe de estar turnado para ingresar la fecha de Siniestro",
                        "info"
                    );
                }

            }
            else if (dato == 'causa') {
                this.editacausa = !this.editacausa;
                this.causa = this.detalleReporteData.svcausa;
            }
            else if (dato == 'denuncia') {
                this.editadenuncia = !this.editadenuncia;
                this.denuncia = this.detalleReporteData.svjuzgado;
            }
            else if (dato = 'tiposervicio') {
                this.editatiposer = !this.editatiposer;
                this.robo = '';
                await Reporte.TipoServicio(this).then(data => {
                    console.log(data, this.TipoRobo.length);
                    this.tiposervicio = data;
                    this.servicio = this.detalleReporteData.tsclave;
                    if (this.seleccion != '') {
                        for (let x in data) {
                            if (data[x].tsclave == this.detalleReporteData.tsclave) {
                                this.servicios = data[x];
                            }
                        }

                        this.changeServicio(this.servicio);

                    }
                });
                this.robo = this.detalleReporteData.trclave;
                this.mercancia = this.TipoRobo.IsMerc == 'true' ? true : false;
                this.efectivo = this.TipoRobo.IsEfec == 'true' ? true : false;
                this.activofijo = this.TipoRobo.IsActivoF == 'true' ? true : false;
                if (Object.keys(this.TipoRobo).length > 0) {
                    this.montomer = this.TipoRobo.montoMer != '' ? this.TipoRobo.montoMer.replace(/([^0-9\.\-])/g, '') : '';
                    this.montoefe = this.TipoRobo.montoEfe != '' ? this.TipoRobo.montoEfe.replace(/([^0-9\.\-])/g, '') : '';
                    this.montoact = this.TipoRobo.montoActivoF != '' ? this.TipoRobo.montoActivoF.replace(/([^0-9\.\-])/g, '') : '';
                }

                this.hand = this.TipoRobo.IsHandH == 'true' ? true : false;
                this.tablet = this.TipoRobo.IsTablet == 'true' ? true : false;
                this.lap = this.TipoRobo.IsLap == 'true' ? true : false;
                this.impresora = this.TipoRobo.IsImpre == 'true' ? true : false;
                this.observacion = this.detalleReporteData.TipoServicioOtro;

            }
        },
        Cancelar(dato) {
            if (dato == 'Asegurado') {
                this.editasegurado = true;
                this.asegurado = {};
            }
            else if (dato == 'Posible') {
                this.editaposible = true;
                this.posibleconclusion = [];
                this.validarposible = false;
            }
            else if (dato == 'Auto') {
                this.editaauto = true;
                this.auto.placa = '';
                this.auto.monto = this.detalleReporteData.samontoazul.replace(/([^0-9\.\-])/g, '');
            }
            else if (dato == 'siniestro') {
                this.editasiniestro = true;
            }
            else if (dato == 'ajustador') {
                this.editaajustador = true;
            }
            else if (dato == 'causa')
                this.editacausa = true;
            else if (dato == 'denuncia')
                this.editadenuncia = true;
            else if (dato == 'tiposervicio')
                this.editatiposer = true;
        },
        async ValidaEditar() {

            var datosReporte = new FormData();
            datosReporte.append("reporte", this.datos.nrreporte);
            datosReporte.append("indice", this.datos.svindice);
            datosReporte.append("aiclave", this.datos.aiclave);
            await General.ValidarEdiccion(this, datosReporte).then(data => {
                if (data) {
                    this.validaEdicion = true;
                    this.validaposible = true;
                }

            });
            await General.Precierre(this, datosReporte).then(data => {
                this.precierre = data;
            });

            await MetodosGenerales.verificarPermisoSolo(this.domain.domainNameForApi, "VerificarPermiso", '49, 297, 359, 223').then(response => {//ver pagos
                if (response.data.length > 0) {
                    response.data.forEach(object => {
                        if (object.peclave == 49)
                            this.permisolider = true;
                        else if (object.peclave == 297)
                            this.PermisoSinIVR = true;
                        else if (object.peclave == 359)
                            this.peredicion = true;
                        else if (object.peclave == 223)
                            this.pertiposer = true;
                    });
                }
            });
        },
        filter: function (evt) {
            evt = (evt) ? evt : window.event;
            let expect = evt.target.value.toString() + evt.key.toString();

            if (!/^[-+]?[0-9]*\.?[0-9]*$/.test(expect)) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        seleccion() {
            if (this.posibleconclusion.length != 0)
                this.validarposible = false;
        },
        async clickCitas() {
            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Reporte/Citas' });
            //this.$router.push({ name: 'citasRLV' }).catch((error) => error);
        },
        async Reasignaciones() {

            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Reasignacion' });
            //this.$router.push({ name: `ReasignacionRLV` }).catch((error) => error);
        },
        async ReasignacionesLider() {

            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/ReasignacionLider' });
            //this.$router.push({ name: `ReasignacionLiderRLV` }).catch((error) => error);
        },
        async Seguimiento() {
            this.datos.urlname = this.$route.name;
            await MetodosGenerales.guardarEnSesionInfoReporte(this.datos, 'reporte');
            this.$router.push({ path: this.asistenciaurl + '/Seguimiento' });
            //this.$router.push({ name: `SeguimientoGeneralRLV` }).catch((error) => error);
        },
        clickWhatsapp() {
            this.$router.push({ name: "Whatsapp" }).catch(() => true);
        },
        async RevisarNotificacion() {
            let noti = await WhatsappService.Notification(this, this.datos);

            if (noti.result != null) {
                var isNot = noti.result.Datos[0].Column1;
                if (isNot == "1") {
                    this.showDot = true;
                }
            }
        },
        async DatosDetalle() {
            let data = await Reporte.DatosDetalle(this);
            let auxDetalleReporte = data[0];
            for (const [key, value] of Object.entries(auxDetalleReporte)) {
                if (typeof value == "object") { auxDetalleReporte[key] = "" } else { auxDetalleReporte[key] = value.toString() }
            }
            this.detalleReporteData = auxDetalleReporte;

            this.svrobo = this.detalleReporteData.svrobo.toLowerCase() === "true";
            this.detalleReporteData.svesmonto = MetodosGenerales.regresarValorMoneda(
                this.detalleReporteData.svesmonto,
                "$"
            );
            if (this.detalleReporteData.trdesc == "Otros") {
                let data2 = await Reporte.ObtenerTipoRobo(this);
                let auxTipoRobo = data2;
                for (const [key, value] of Object.entries(auxTipoRobo)) {
                    if (typeof value == "object") {
                        auxTipoRobo[key] = "";
                    } else {
                        auxTipoRobo[key] = value.toString();
                    }
                }
                this.TipoRobo = auxTipoRobo;
                this.TipoRobo.montoMer = MetodosGenerales.regresarValorMoneda(
                    this.TipoRobo.montoMer,
                    "$"
                );
                this.TipoRobo.montoEfe = MetodosGenerales.regresarValorMoneda(
                    this.TipoRobo.montoEfe,
                    "$"
                );
                this.TipoRobo.montoActivoF = MetodosGenerales.regresarValorMoneda(
                    this.TipoRobo.montoActivoF,
                    "$"
                );
            }
            if (this.detalleReporteData.tsclave == 8) {
                this.detalleReporteData.TipoServicioOtro =
                    await Reporte.ObtenerTipoServicioOtro(this);
            }

            if (this.detalleReporteData.tsclave == '1') {
                let trclave = this.detalleReporteData.trclave;
                if (trclave == '1' || trclave == '6' || trclave == '7' || trclave == '8') {
                    this.fechasiniestro = true;
                }
            }

            //this.detalleReporteData.samontoazul = MetodosGenerales.regresarValorMoneda(this.detalleReporteData.samontoazul, "$");
            if (this.detalleReporteData.samontoazul != 0)
                this.detalleReporteData.samontoazul = MetodosGenerales.regresarValorMoneda(this.detalleReporteData.samontoazul, "$");
            else
                this.detalleReporteData.samontoazul = '';



            let formdata = new FormData();
            formdata.append("nrreporte", this.datos.nrreporte);
            formdata.append("svindice", this.datos.svindice);
            formdata.append("clclave", this.detalleReporteData.clclave);
            await General.ValidacionRegex(this, formdata).then(data => {
                this.user = data[0].uslogin;
                this.regex = data[0].regex;
                this.place = data[0].place;
                this.mensage = data[0].mensaje;
            });


            this.showcargando = false;
        },
        async CerrarVisor() {
            var img = {
                src: '@/',
                type: 'img'
            }
            this.media = [];
            this.media.push(img);
            this.showLightbox = false;
            await this.$refs.lightbox.showImage(0);
        },
        async VerContrato() {
            this.showLightbox = false
            this.overlay = true;
            this.media = this.media.filter(obj => obj.src == '@/');

            //  ruta/NombreDelArchivo.ext
            let arr = this.detalleReporteData.clrutacontrato.split("/")
            let archivosResponse = await ArchivosService.ObtenerContrato(arr[0], arr[1])
                .catch((e) => {
                    console.log('error: ', e);
                })

            if (archivosResponse.error) {
                this.$swal({
                    position: 'center',
                    icon: "warning",
                    title: "Algo salió mal",
                    text: archivosResponse.msg,
                    showConfirmButton: true,
                    confirmButtonColor: '#536DFE',
                    confirmButtonText: 'Aceptar',
                    allowOutsideClick: false,
                    timer: 3000
                })

                this.overlay = false;
                return;
            }

            await this.RegistrarVisita(archivosResponse.archivo);

            let isPDF = /\.pdf$/i.test(archivosResponse.archivo);

            var file = {
                src: archivosResponse.watch,
                caption: '<h4> Contrato </h4>',
                type: isPDF ? 'pdf' : 'img',
                width: '800px',
                // docid: 123, 
                paginas: 1,
                archivo: archivosResponse.archivo
            };

            this.media.push(file);
            this.media = this.media.filter(obj => obj.src !== '@/');
            this.overlay = false;
            this.showLightbox = true
        },
        async RegistrarVisita(nombreArchivo) {
            var formData = new FormData();
            formData.append("lasitio", 'Prusia+');
            formData.append("lomodulo", 'RLV-ReporteDetalle');
            formData.append("laaccion", "Vio contrato");
            formData.append("lacaracteristicas", this.datos.nrreporte + '-' + this.datos.svindice);
            formData.append("lanombre", nombreArchivo);
            formData.append("ladestinatario", "");

            await ArchivosService.AlmacenarVisitas(formData);
        },
    },
};
</script>
<style scoped>
.text-subtitle {
    font-size: 12.8px;
    font-weight: 700;
}

.label-text2 {
    font-family: "Roboto", sans-serif;
    font-weight: 700 !important;
    font-size: 20px !important;
    margin-bottom: 0px !important;
}

.btnAbo {
    background-color: #536dfe;
    font-size: 20px !important;
    height: 40px !important;
    width: 40px !important;
    margin-left: 5px;
    /*margin-right: 10px;*/
}

.btnAboNew {
    background-color: #555;
    font-size: 100px !important;
    height: 20px !important;
    width: 20px !important;
}


.btnsAbo {
    flex-wrap: initial !important;
}


.btnMedalla {
    width: 40px;
    height: 40px;
    min-width: fit-content;
    margin-right: 15px
}


@media screen and (max-width: 1300px) {
    .btnMedalla {
        width: 40px;
        height: 40px;
        min-width: fit-content;
        margin-right: 35px
    }
}


@media screen and (max-width: 1400px) and (min-width: 1280px) {
    .btnMedalla {
        width: 40px;
        height: 40px;
        min-width: fit-content;
        margin-right: 35px;
        margin-left: 10px;
    }
}
</style>
<style lang="scss">
@media screen and (max-width: 600px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 0.9rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 600px) and (max-width: 960px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 960px) and (max-width: 1264px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.1rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1264px) and (max-width: 1904px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.2rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.3rem;
        font-weight: 700;
    }
}

@media only screen and (min-width: 1904px) {
    #DatosGenerales .v-list-item__title {
        font-weight: 100;
        font-size: 1.3rem;
    }

    #DatosGenerales .vs-list--subtitle {
        font-size: 1.4rem;
        font-weight: 700;
    }
}

#correo .list-titles {
    max-width: -webkit-fill-available !important;
}

.vue-lb-container {
    margin-top: 25px
}
</style>
